<template>
  <router-view />
  <FooterContent />
</template>

<script setup>
import { onMounted } from "vue";
import FooterContent from '@/components/footer/FooterContent.vue'
onMounted(() => {
  document.addEventListener("contextmenu", (e) => e.preventDefault());
});
</script>

<style>
body {
  background-color: #ecfcff;
  padding: 0;
  margin: 0;
}

#app {
font-family: "Hiragino Sans", "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ ProN W3", Meiryo, メイリオ, Osaka, "MS PGothic", arial, helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  max-width: 460px;
  margin: 0 auto;
  background-color: white;
  /* min-height: 100vh; */
  height: auto;
}

body {
  background-color: #ecfcff;
  padding: 0;
  margin: 0;
}

.font-bold {
  font-weight: bold;
}

.double-circle {
  width: 30px;
  height: 30px;
  position: relative;
  border: solid #fa8072 3px;
  border-radius: 50%;
  box-sizing: border-box;
  margin: 0 auto;
  margin-bottom: 5px;
}

.double-circle::before {
  content: "";
  width: 15px;
  height: 15px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: solid #fa8072 3px;
  border-radius: 50%;
  box-sizing: border-box;
}

.cross {
  position: relative;
  width: 40px;
  height: 40px;
  margin: 0 auto;
}

.cross::before,
.cross::after {
  content: "";
  position: absolute;
  top: 18px;
  left: -4px;
  width: 40px;
  height: 6px;
  background: #607d8b;
}

.cross::before {
  transform: rotate(45deg);
}

.cross::after {
  transform: rotate(-45deg);
}


.circle {
  width: 25px;
  height: 25px;
  border: 3px solid #409fca;
  border-radius: 50%;
  margin: 0 auto;
  margin-bottom: 5px;
}

.triangle {
  --b: 8px;
  width: 40px;
  aspect-ratio: 1/cos(30deg);
  clip-path: polygon(50% 0, 100% 100%, 0 100%, 50% 0, 50% var(--b), calc(var(--b)*cos(30deg)) calc(100% - var(--b)/2), calc(100% - var(--b)*cos(30deg)) calc(100% - var(--b)/2), 50% var(--b));
  background: #ffc107;
  margin: 0 auto;
  margin-bottom: 5px;
}

.bold-red {
  color: #e74c3c;
  font-weight: 700;
}

.under-yellow {
  background: linear-gradient(transparent 65%, rgb(253 233 61) 50%);
  font-weight: 600;
}

.bold-font {
  font-weight: 500;
}

.annotation {
  font-size: 10px;
  color: gray;
}
</style>
